import { _t } from "app/i18n/i18n";

export const getPeriodicalsFromMenuData = (menuData, assetClass, region, lang) => {
  const data = menuData?.["periodicals." + lang];
  if (!data) return [];

  let periodicals = [];
  if (!region || !region.length) {
    if (!["Home", "Economics", "FX", "Rates"].includes(assetClass)) {
      periodicals = getPeriodicals(data, assetClass, "All");
    } else {
      periodicals = groupByRegion(data, assetClass);
    }
  } else {
    periodicals = getPeriodicals(data, assetClass, region);
  }

  periodicals = [_t("All Periodicals"), ...periodicals];

  return periodicals;
};

// Flattens periodicals tree and adds Region labels
// {EMEA: [...], Americas: [...]} -> [{label: EMEA}, [...], {label: Americas}, [...]]
function groupByRegion(data, assetClass) {
  const periodicals = Object.entries(data[assetClass] || [])
    .map(([region, periodicals]) => [{ heading: _t(region), value: "disabled" }, ...periodicals])
    .flat();
  return periodicals;
}

const getPeriodicals = (data, assetClass, region) => data?.[assetClass]?.[region] || [];


export const hideHeadings = (periodicals = []) => periodicals.filter((p) => !p.heading);
